import type { ReactNode } from 'react';

export interface StickyFooterProps {
  /** Acciones secundarias, a la izquierda: volver, cancelar. */
  secondary?: ReactNode;
  /** Acción principal, a la derecha: continuar, guardar. */
  primary: ReactNode;
  /** Texto de contexto entre ambas — por ejemplo "Paso 3 de 6". */
  hint?: ReactNode;
  className?: string;
}

/**
 * Barra de acciones pegada al pie del contenedor.
 *
 * Existe porque los formularios del wizard son largos: con los botones al final
 * del scroll, quien completa un paso tiene que bajar a buscar "Continuar" y no
 * siempre encuentra que existe. Pegada, la salida está siempre a la vista.
 *
 * `sticky` y no `fixed`: `fixed` la sacaría del flujo y quedaría flotando sobre
 * páginas que no la pusieron, incluidos los modales.
 */
export function StickyFooter({ secondary, primary, hint, className }: StickyFooterProps) {
  return (
    <div
      data-testid="sticky-footer"
      className={`sticky bottom-0 z-10 flex items-center gap-3 border-t border-edge-subtle bg-surface-base px-6 py-4 ${className ?? ''}`}
    >
      {/* Lo secundario primero en el DOM: al tabular se llega antes a "volver"
          que a "continuar", que es el orden en que se leen. */}
      {secondary ?? null}

      {hint ? (
        <span className="flex-1 text-sm text-content-tertiary">{hint}</span>
      ) : (
        <span className="flex-1" />
      )}

      {primary}
    </div>
  );
}
